export const mockData = {
  hero: {
    title: "MonDiagImmo",
    subtitle: "Expertise en Diagnostics Immobiliers à Marseille",
    description: "Professionnalisme, rigueur et accompagnement personnalisé pour tous vos diagnostics immobiliers",
    cta: "Demander un devis"
  },
  services: [
    {
      id: 1,
      title: "DPE",
      subtitle: "Diagnostic de Performance Énergétique",
      description: "Évaluation précise de la performance énergétique de votre bien immobilier",
      icon: "Zap"
    },
    {
      id: 2,
      title: "Amiante",
      subtitle: "Diagnostic Amiante",
      description: "Détection et repérage des matériaux contenant de l'amiante",
      icon: "Shield"
    },
    {
      id: 3,
      title: "Plomb",
      subtitle: "Constat de Risque d'Exposition au Plomb",
      description: "Analyse des revêtements pour détecter la présence de plomb",
      icon: "AlertTriangle"
    },
    {
      id: 4,
      title: "Termites",
      subtitle: "État Parasitaire",
      description: "Recherche de présence de termites et autres insectes xylophages",
      icon: "Bug"
    },
    {
      id: 5,
      title: "Gaz & Électricité",
      subtitle: "Diagnostics Installations",
      description: "Vérification de la conformité de vos installations gaz et électriques",
      icon: "Plug"
    },
    {
      id: 6,
      title: "Loi Carrez / Boutin",
      subtitle: "Mesurage Superficie",
      description: "Mesure précise de la superficie habitable de votre bien",
      icon: "Ruler"
    }
  ],
  about: {
    name: "Anaïs",
    age: 35,
    title: "Une Expertise au Féminin",
    description: "Diagnostiqueuse immobilière certifiée à Marseille, je suis Anaïs, fondatrice de MONDIAGIMMO. Issue du domaine de la comptabilité, j'apporte rigueur et précision à la réalisation de diagnostics immobiliers à Marseille et dans les Bouches-du-Rhône (13). En tant que diagnostiqueuse immobilière, j'accompagne particuliers et professionnels avec sérieux, réactivité et transparence, afin de sécuriser chaque projet immobilier grâce à des diagnostics fiables et conformes à la réglementation. Avec MONDIAGIMMO, vous bénéficiez d'un interlocuteur unique, d'un service de proximité et de diagnostics immobiliers à Marseille réalisés dans le respect des normes, des délais et de vos enjeux.",
    image1: "/anais1.jpeg",
    image2: "/anais2.jpeg",
    qualities: [
      {
        title: "Rigueur Comptable",
        description: "Issue du domaine comptable, je porte une attention méticuleuse aux détails"
      },
      {
        title: "Expérience Confirmée",
        description: "Nombreuses années d'expérience dans le diagnostic immobilier"
      },
      {
        title: "Tout le Département 13",
        description: "J'interviens dans toutes les Bouches-du-Rhône depuis Marseille"
      }
    ]
  },
  zone: {
    title: "Zone d'Intervention",
    description: "Tout le département des Bouches-du-Rhône (13)",
    areas: [
      "Marseille (tous arrondissements)",
      "Aix-en-Provence",
      "Aubagne",
      "La Ciotat",
      "Cassis",
      "Martigues",
      "Salon-de-Provence",
      "Arles",
      "Istres"
    ]
  },
  testimonials: [
    {
      id: 1,
      name: "Sophie Martin",
      role: "Propriétaire",
      content: "Professionnalisme exemplaire ! Diagnostic DPE réalisé avec soin et explications claires. Je recommande vivement.",
      rating: 5
    },
    {
      id: 2,
      name: "Jean Dupont",
      role: "Vendeur",
      content: "Très réactive et à l'écoute. Les rapports sont précis et le service est irréprochable. Merci pour votre accompagnement.",
      rating: 5
    },
    {
      id: 3,
      name: "Agence Immobilière Provence",
      role: "Partenaire professionnel",
      content: "Nous travaillons régulièrement avec Mon diag Immo. Toujours ponctuelle, rigoureuse et professionnelle.",
      rating: 5
    }
  ],
  contact: {
    phone: "06 52 54 79 19",
    email: "mondiagimmo13@gmail.com",
    address: "Marseille, Bouches-du-Rhône",
    hours: "Lun - Ven : 9h - 18h"
  }
};